import utils from "../../universal/utils";
import { LEAVER_PENALTY_APPEAL_CATEGORY } from "./leaverPenaltyAppeal";

/** Dark-hero UI keys → API category values */
const UI_TO_API_CATEGORY = {
  technical: "bug",
};

/** API category values → dark-hero UI keys */
const API_TO_UI_CATEGORY = {
  bug: "technical",
  reputation_appeal: "report",
};

export function mapUiCategoryToApi(category, appeal) {
  if (appeal) return LEAVER_PENALTY_APPEAL_CATEGORY;
  return UI_TO_API_CATEGORY[category] || category;
}

export function mapApiCategoryToUi(category) {
  return API_TO_UI_CATEGORY[category] || category;
}

function appendAttachmentNote(description, files) {
  const body = description.trim();
  if (!files?.length) return body;
  const names = files.map((f) => f.name).join(", ");
  return `${body}\n\n---\nReferenced attachments: ${names}`;
}

const MAX_INLINE_IMAGE_BYTES = 3 * 1024 * 1024;

function fileToDataUrl(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => resolve(typeof reader.result === "string" ? reader.result : "");
    reader.onerror = () => resolve("");
    reader.readAsDataURL(file);
  });
}

async function buildAttachmentPayloads(files) {
  const safeFiles = Array.isArray(files) ? files : [];
  return Promise.all(
    safeFiles.map(async (file) => {
      const attachment = {
        name: file.name,
        type: file.type,
        size: file.size,
      };
      if (file.type?.startsWith("image/") && file.size <= MAX_INLINE_IMAGE_BYTES) {
        const dataUrl = await fileToDataUrl(file);
        if (dataUrl) attachment.dataUrl = dataUrl;
      }
      return attachment;
    })
  );
}

export async function submitSupportTicket({
  category,
  email,
  subject,
  description,
  appeal = null,
  attachmentFiles = [],
}) {
  const basePath = utils.getEdgeBasePath();
  const attachments = await buildAttachmentPayloads(attachmentFiles);
  const response = await fetch(`${basePath}/api/v1/support/tickets`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      category: mapUiCategoryToApi(category, appeal),
      email: email.trim(),
      subject: subject.trim(),
      description: appendAttachmentNote(description, attachmentFiles),
      attachments,
      ...(appeal ? { appeal } : {}),
    }),
  });

  let data;
  try {
    data = await response.json();
  } catch {
    return { ok: false, message: "Could not reach the server. Please try again later." };
  }

  if (!data?.ok) {
    return {
      ok: false,
      message: data?.message || "Something went wrong. Please try again.",
    };
  }

  return data;
}
